export default "__VITE_ASSET__BDMvG8$u__"